'use es6';

import { deref, unwatch, watch } from 'atom';
import { isResolved } from 'reference-resolvers/utils';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const getFieldLabel = (reference, value) => reference ? reference.label : value;
export default class DisplayValueProperty extends PureComponent {
  constructor() {
    super();
    this.handleReferenceChange = reference => {
      if (isResolved(reference)) {
        this.setState({
          reference
        });
      }
    };
    this.state = {
      reference: null
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    this.mountResolver();
  }
  componentDidUpdate(prevProps) {
    const {
      value
    } = this.props;
    if (prevProps.value !== value) {
      this.mountResolver();
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleReferenceChange);
    }
  }
  mountResolver() {
    const {
      getFamilyValueResolver,
      operator,
      value
    } = this.props;
    const resolver = getFamilyValueResolver(operator);
    if (resolver && resolver.byId) {
      if (this.referenceAtom) {
        unwatch(this.referenceAtom, this.handleReferenceChange);
      }
      this.referenceAtom = resolver.byId(value);
      watch(this.referenceAtom, this.handleReferenceChange);
      this.handleReferenceChange(deref(this.referenceAtom));
    }
  }
  render() {
    const {
      value
    } = this.props;
    const {
      reference
    } = this.state;
    const propertyLabel = getFieldLabel(reference, value);
    return /*#__PURE__*/_jsx("span", {
      children: propertyLabel
    });
  }
}
DisplayValueProperty.propTypes = {
  getFamilyValueResolver: PropTypes.func.isRequired,
  operator: FilterOperatorType,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};